import React, { useEffect, useState } from "react";
import { Link }                       from "react-router-dom";
import { AxiosResponse }              from "axios";
/* Project References */
import { Contact }            from "../../../models/Admin/Contact";
import { PageableCollection } from "../../../models/PageableCollection";
import Pagination             from "../../../components/Pagination";
import SkeletonTableLoad      from "../../../components/SkeletonTableLoad";
import DeleteDialog           from "../../../components/DeleteDialog";

import msalRestClient from "../../../services/clients/MsalRestClient";

const Contacts = () => {

    // #region Init States

    let emptyCollection: PageableCollection<Contact> = {
        totalPages : 0,
        count      : 0,
        next       : "",
        previous   : "",
        results    : []
    }

    // #endregion

    // #region States & Hooks

    const [page, setPage]           = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [contacts, setContacts]   = useState<PageableCollection<Contact>>(emptyCollection);

    useEffect(() => { fetchFromApi(page); }, [])

    // #endregion

    /**
     * ...
     * @param pageRequest
     */
    const fetchFromApi = (pageRequest: number) => {

        setIsLoading(true);
        setPage(pageRequest);

        let endpoint = "/api/contacts?page" + page;

        msalRestClient.get(endpoint)
            .then(response => onApiSuccess(response))
            .catch(error   => console.error("API Exception: " + error))
            .finally(()    => setIsLoading(false));
    }

    /**
     * ...
     * @param response
     */
    const onApiSuccess = (response: AxiosResponse<PageableCollection<Contact>, any>) => {

        if (response.status === 200) {
            setContacts(response.data);
        }
        else if (response.status === 204) {
            setContacts(emptyCollection);
        }
    }

    /**
     * ...
     * @param index
     */
    const handleDelete = (index?: number) => {

        if (index && index > -1)
        {
            let contact = contacts.results.at(index);
            if (contact)
            {

            }
        }
    }

    // JSX Element for rendering in browser
    return (
        <main className="container">

            <div className="row">

                <div className="col-12 col-md-6 mb-2">
                    <button className="btn btn-success">
                        <i className="bi bi-plus-lg"></i>
                    </button>
                </div>

                <div className="col-12 col-md-6">
                    <Pagination currentPage={page} onPageChange={fetchFromApi} next={contacts.next} previous={contacts.previous} count={contacts.count} totalPages={contacts.totalPages} />
                </div>

                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-body">
                            {
                                isLoading ? <SkeletonTableLoad columnCount={5} rowCount={15} striped={false} />
                                    :
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Jobtitle</th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                contacts.results.map((value, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{value.id}</td>
                                                            <td>{value.firstname + " " + value.lastname}</td>
                                                            <td>{value.email}</td>
                                                            <td>{value.jobTitle}</td>
                                                            <td>
                                                                <Link to={"/admin/event/" + value.id} className="btn btn-warning me-2">
                                                                    <i className="bi bi-pencil"></i>
                                                                </Link>
                                                                <DeleteDialog index={index} title="Please confirm ..." description="Do you really want to delete the record?" btnClass="btn btn-danger" btnIcon="bi bi-trash" key={"btnDelete_" + index} onConfirm={handleDelete} />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                            }
                        </div>
                    </div>
                </div>

            </div>

        </main>
    )
}
export default Contacts;